import app from 'flarum/forum/app';
import extractText from 'flarum/common/utils/extractText';
/**
 * The "Prénom / Nom / Localisation / Site web perso" plain-text Form-group
 * block - shared between SignUpModal (addRegistrationFields.js) and the
 * settings page (addProfileSettings.js), since it's the exact same four
 * fields in both places (see associationsField.js for the fifth field,
 * shared the same way). `priority`/`step` let each caller keep its own
 * relative spacing in its own ItemList (registration uses 5..2, settings
 * uses 50..20) without this helper hardcoding either.
 */
export default function addProfileFieldItems(items, _ref) {
  let {
    firstName,
    lastName,
    location,
    website,
    disabled,
    priority,
    step = 1,
    labelSuffix
  } = _ref;
  const label = key => extractText(app.translator.trans(`champis-users.forum.profile_fields.${key}`));

  // [item key, label key, input type, placeholder key (the label itself
  // when there's no better example of what to type), value]
  const fields = [['champisFirstName', 'first_name_placeholder', 'text', 'first_name_placeholder', firstName], ['champisLastName', 'last_name_placeholder', 'text', 'last_name_placeholder', lastName], ['champisLocation', 'location_placeholder', 'text', 'location_example', location], ['champisWebsite', 'website_placeholder', 'url', 'website_example', website]];
  fields.forEach((_ref2, index) => {
    let [key, labelKey, type, placeholderKey, stream] = _ref2;
    items.add(key, m("div", {
      className: "Form-group"
    }, m("label", {
      className: "label"
    }, label(labelKey), labelSuffix?.()), m("input", {
      className: "FormControl",
      type: type,
      placeholder: label(placeholderKey),
      "aria-label": label(labelKey),
      bidi: stream,
      disabled: disabled
    })), priority - index * step);
  });
}
flarum.reg.add('champis-users', 'forum/utils/addProfileFieldItems', addProfileFieldItems);